import type { ContentPage } from "@/lib/content/types";

// CRM › Sales Enablement › Zoom Meeting Integration (leaf).
export const zoomMeetingIntegration: ContentPage = {
  slug: "sales-enablement/zoom-meeting-integration",
  template: "hrmsFeature",
  seo: {
    title: "Zoom Meeting Integration for CRM | GetBiz CRM",
    description: "Schedule and launch Zoom meetings from GetBiz CRM. Book, join and log video calls against deals and contacts, with notes captured automatically.",
    keywords: ["zoom crm integration", "video meeting crm", "zoom sales meetings", "crm video calls"],
    ogImage: "/assets/data/seoimages/zoom-meeting-integration.webp",
  },
  leaf: {
    hero: {
      caption: "Zoom Meeting Integration",
      title: "Run and Log Zoom Meetings From the CRM",
      description: "Schedule, launch and record Zoom meetings straight from a deal — with every meeting and note captured on the record.",
      h1: "caption",
    },
    split: {
      title: "Why Teams Choose Zoom Meeting Integration",
      bullets: [
        { title: "Schedule From Deals", description: "Create Zoom meetings without leaving the CRM." },
        { title: "One-Click Join", description: "Launch calls from the contact record." },
        { title: "Auto-Logged", description: "Meetings and notes land on the deal." },
        { title: "Follow-Up Ready", description: "Turn call outcomes into next steps." },
      ],
      image: "/assets/images/img/product/crm/zoom-meeting-integration-lead-image.webp",
      imageAlt: "Zoom Meeting Integration — GetBiz CRM",
    },
    cardsHeading: {
      title: "Works With the Rest of Sales Enablement",
      description: "Zoom Meeting Integration connects to every other part of Sales Enablement in GetBiz CRM.",
    },
    cards: [
      { title: "Finance", href: "/crm-software/sales-enablement/finance/", description: "Manage quotes, invoices and payments alongside deals so revenue moves from closed-won to collected without gaps.", image: "/assets/images/img/product/crm/finance.webp", imageAlt: "GetBiz CRM finance" },
      { title: "Configure, Price, Quote (CPQ)", href: "/crm-software/sales-enablement/configure-price-quote/", description: "Configure products, apply the right pricing and generate professional quotes instantly.", image: "/assets/images/img/product/crm/configure-price-quote.webp", imageAlt: "GetBiz CRM configure, price, quote (cpq)" },
      { title: "Documents Library", href: "/crm-software/sales-enablement/documents-library/", description: "Store, share and track proposals, decks and contracts from a central library, right where your deals live.", image: "/assets/images/img/product/crm/documents-library.webp", imageAlt: "GetBiz CRM documents library" },
      { title: "Calendar", href: "/crm-software/sales-enablement/calendar/", description: "Sync calendars, share booking links and see all your meetings next to the deals and contacts they belong to.", image: "/assets/images/img/product/crm/calendar.webp", imageAlt: "GetBiz CRM calendar" },
    ],
    testimonials: {
      title: "Businesses across India love & trust GetBiz!",
      description: "See why teams choose GetBiz CRM to run their sales.",
    },
    bookDemoTitle: "See Zoom Meeting Integration in action.",
    relatedBlogs: "static",
    metaKey: "sales-enablement-zoom-meeting-integration",
  },
  sections: [],
};
